import * as React from 'react';
import { Link } from 'react-router-dom';
import { ReadView } from '../../../../components/form-elements/ReadView';
import { Routes } from '../../../../utils/app-constants';
import { toLocalDateString } from '../../../../utils/date-utils';
import { ShipmentActionType } from '../../../../transportation/models/enums/shipment-action-type';
import { DeliveryShipmentAction, EndShipmentAction, ShipmentAction, StartShipmentAction } from '../../../../transportation/models/shipments/shipment-action';
import { TruckRead } from '../../../../transportation/models/trucks/truck-read';
import { RouteDisplay } from '../../../../transportation/components/mapping/RouteDisplay';
import { ImportCustomerDeliverRow, ImportDestinationRow, ImportOriginRow } from './ImportRouteStopRow';

interface IProps {
    route: TruckRead;
    tIndex: number;
    onSave: any;
}

export const ImportRouteRow = (props : IProps) => {

    const [nameCopy, setNameCopy]       = React.useState('');
    const [isDebug]                     = React.useState(false);
    
    React.useEffect(() => {
        if (props.route) {
            setNameCopy(props.route.name);
        }
    }, [props.route]);

    const onNameChange = (e : any) => {
        setNameCopy(e.target.value);
    };  

    const getDepartureTime = () => {
        const origin = props.route.actions.find((itm : ShipmentAction) => {
            return itm.type === ShipmentActionType.Origin;
        });

        if (origin) {
            const tmp = origin as StartShipmentAction;
            return tmp.actionTime ? toLocalDateString(tmp.actionTime.local, tmp.address.timeZoneId) : '';
        }
        else {
            return "No Departure Time";
        }
    };

    const getReturnTime = () => {
        const origin = props.route.actions.find((itm : ShipmentAction) => {
            return itm.type === ShipmentActionType.Destination;
        });

        if (origin) {
            const tmp = origin as EndShipmentAction;
            return tmp.actionTime ? toLocalDateString(tmp.actionTime.local, tmp.address.timeZoneId) : '';
        }
        else {
            return "No Return Time";
        }
    };

    const getTableRow = (itm : ShipmentAction, idx : number) => {

        switch (itm.type) {
            case ShipmentActionType.Delivery:
                return <ImportCustomerDeliverRow key={ idx } stop={ itm as DeliveryShipmentAction } index={ idx }/>;
            case ShipmentActionType.Origin:
                return <ImportOriginRow key={ idx } origin={ itm as StartShipmentAction } index={ idx }/>;
            case ShipmentActionType.Destination:
                return <ImportDestinationRow key={ idx } destination={ itm as EndShipmentAction } index={ idx }/>;
            default:
                return null;
        }
    };

    return  <div className="row">
                <div className="col-md-12">

                    <div className="import-route-row">

                        <div className={`import-route-row-title ${ props.route.isDisabled ? 'view-mode' : ''}`}>
                            <div className="col-md-9">
                                <div className="row-stripe" />
                                <h2>Truck Name:</h2>
                                <input 
                                    className="form-control" 
                                    type="text" 
                                    tabIndex={ props.tIndex + 1 }
                                    disabled={ props.route.isDisabled }
                                    onChange={ onNameChange }
                                    value={ nameCopy } />
                            </div>
                            <div className="col-md-3">
                                {
                                    props.route.isDisabled
                                        ? <Link
                                            to={ Routes.SHIPPING_TRUCK_EDIT_WITH_ID.formattify(props.route.id) }
                                            target="_blank"
                                            tabIndex={ props.tIndex + 2 }
                                            className="btn new import-route-row-button">
                                            Open In New Tab
                                        </Link>
                                        : <button 
                                            onClick={ () => props.onSave(nameCopy, props.route.tmpClientId) }
                                            tabIndex={ props.tIndex + 2 }
                                            disabled={ nameCopy.length === 0 }
                                            className="btn new import-route-row-button">
                                            Import
                                        </button>
                                }
                            </div>    
                                                   
                        </div>

                        {
                            !props.route.isDisabled
                                ? <React.Fragment>
                                    <div className="import-route-row-summary">
                                        <div className="col-md-6">
                                            <ReadView
                                                label="Departs On"
                                                value={ getDepartureTime() } />
                                            <ReadView
                                                label="Returns On"
                                                value={ getReturnTime() } />
                                            <ReadView
                                                label="Total Distance"
                                                value={ props.route.totalDistance }/>
                                            <ReadView
                                                label="Travel Time"
                                                value={ props.route.totalTravelTime } />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="map-wrap">
                                                {
                                                    isDebug 
                                                        ? "Disabled to Save Money"
                                                        : <RouteDisplay
                                                            allStops={ props.route.actions }
                                                            useMiniMarker={ true }
                                                            selectedID={ 0 }
                                                            showRoute={ false }
                                                            onMarkerClick={ () => { return; } }
                                                        />
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="import-route-row-stops">
                                        <div className="col-md-12">
                                            <table className="table table-stripped">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Name</th>
                                                        <th>Mileage</th>
                                                        <th>Travel Time</th>
                                                        <th>Address</th>
                                                        <th>Order Count</th>
                                                        <th>Shipment Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    props.route.actions.map((tmp: ShipmentAction, idx : number) =>
                                                        getTableRow(tmp, idx)
                                                    )
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </React.Fragment>
                                : null
                        }
                    </div>
                </div>
            </div>;
};
